import React from 'react';
import MicroApp from '@/components/micro-app';
import { LOCATION_EMBEDDED } from '../constants';
import env from '@/env';
import { tbInMyCreate } from '../goto-tb';

// 自动选品:    #/pandora-goods-pool
// 人工选品:    #/pandora-goods-pool/manual
// 聚合商品池:   #/pandora-goods-pool/aggregation
// 导购魔方:     #/guiding-box
// 直播:        #/live
// 智能feeds流:  #/feeds-flow
// 定制化榜单:    #/fresh-list
// 优惠券池:      #/coupon-pool
// 内容Feeds流   #/content-feeds
function Launch(props: any) {
  const { data, onDataChange, ..._props } = props;

  return (
    <MicroApp
      data={{ ...tbInMyCreate, locationEmbedded: LOCATION_EMBEDDED, ...data }}
      {..._props}
      destory
      name="tfLanuch"
      url={`${env.ACE_DOMAIN}/launch`}
      onDataChange={onDataChange}
    />
  );
}

export default Launch;
